import React, {useState, useEffect} from 'react'
import { Container, Button, Card, Col, Row} from 'react-bootstrap';
import { handleApiErrors } from "../../api/handleApiErrors";
import * as blogCriteriaApi from './../../api/blogCriteriaApi';
import { useSignalAbort } from '../../api/useSignalAbort';

function BlogReadmore() {
  const abortConstants = useSignalAbort()
  const [isLoading, setIsLoading] = useState({});
  const [isHovered, setIsHovered] = useState(false);
  const [blogList, setBlogList] = useState([]);

 
    const captionStyle = {
        padding: '2px',
        marginBottom: '10px',
        boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)', // Increase the box shadow
        borderRadius: '10px',
        border: 'none', // Remove the border
        width: '100%',
        height:'465px'
      };
      const captionTextStyleP = {
        fontSize: '1.1rem', 
        width:'100%' ,
        textAlign:'center',
        lineHeight: "2",
        fontWeight: 700
      }
      const imageStyle = {
        width: "100%",
        maxWidth: "100%", // Adjust the maximum width as needed
        height: "300px",
        filter: "opacity(3) brightness(1)",
      };
    
      const buttonStyle = {
        fontSize: "15px",
        fontWeight: 600,
        padding: "10px",
        border: "none",
        backgroundColor: isHovered ? "#F7F9FF" : "#2855A1",
        color: isHovered ? "black" : "White",
        transition:"background-color 0.5s ease-in-out, color 0.5s ease-in-out, transform 0.3s",
        transform: isHovered ? "translateX(10px)" : "translateX(0)",
      };

      useEffect(() => {
        getAllData(abortConstants.controllerConfig)
      },[])
    
    
      const getAllData = (abortToken) => {
        getAllBlogbyCriteria(abortToken)
      }
      
    
    //Bloglist
    const getAllBlogbyCriteria = async (abortToken) => {
      try {
         const result = await blogCriteriaApi.getBlogCriteria(abortToken)
        
        setBlogList(result.data.Blogs)
        console.log(result.data.Blogs);
      }
      catch (error) {
         console.log(error);
         handleApiErrors(error, 'BlogsListing', 'blogsListing_response', 'blogsListing_timeout', 'blogsListing_request', setIsLoading);
    
      }
    }

  return (
    <Container
      fluid
      style={{
        marginBottom: "80px",
        height: "auto",
        marginTop: "10px",
      }}
    >
        
        
        <Container className="d-flex align-items-center justify-content-center" style={{ marginTop: '25px', marginBottom:'50px' }}>
          <h1 className="text-lg" style={captionTextStyleP}>
            Explore our blogs for a rich mix of industry trends, government policies, and expert advice. Discover inspiring stories and essential updates that keep you informed and ahead in your professional and business endeavours.
          </h1>
        </Container>


      <Container style={{ padding: "2px", marginTop: "50px" }}>
        <Row className="justify-content-center">

{blogList?.map((blog) => (
 <Col xs={12} sm={12} md={6} lg={4}>
 <Card  style={captionStyle}>
   <Card.Img
     variant="top"
     src={`${process.env.REACT_APP_BASE_URL}${blog.Image}`}

    //  src={process.env.PUBLIC_URL + "/assets/images/BlogCard1.png"}
     style={imageStyle}
     className="img-fluid" // Add the Bootstrap class for responsive images
     alt=""
   />
   <Card.Body>
     <Card.Text style={{ fontWeight: 600, fontSize: '18px' , letterSpacing:0 , lineHeight: "25px", textAlign:'justify'}}>
     {blog.Title}: <br/> {blog.Content}
       </Card.Text>
        
     <div className="d-flex justify-content-between align-items-center" style={{ marginLeft: '10px', marginRight: '10px' }}>
       <span>15 Jan 2024</span>

       <Button
  as="a" // Use the 'as' prop to render the button as an anchor
  href={blog.ExternalUrl} // Set the href attribute to the ExternalUrl
  target="_blank" // Open the link in a new tab/window
  rel="noopener noreferrer" // Recommended for security reasons when using target="_blank"
  variant="primary"
  style={buttonStyle}
>
 Go Somewhere
</Button>


     </div>

   </Card.Body>
 </Card>
</Col>
))}
         

           

        </Row>
      </Container>




    </Container>
  );
}

export default BlogReadmore